class ProductMediaCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    if (!this.els.slide || this.els.slide.elements.length < 2) return

    this.startY = 0
    this.setupCheck()
    this.setImageHeight()
    this.initialAnimation()
  }

  setupListeners () {
    this.windowSize = window.innerWidth

    window.addEventListener('resize', this.onResize.bind(this))
    document.addEventListener('variantChange', this.OnVariantChange.bind(this))

    this.els?.dot?.elements.forEach(dot => {
      dot.addEventListener('click', this.onDotClick.bind(this))
    })

    this.externalEls?.thumbnail?.elements.forEach((el) => {
      el.addEventListener('click', this.onThumbnailClick.bind(this))
    })
  }

  initialAnimation () {
    const hasCarousel = this.carousel != null

    if (hasCarousel) {
      const slides = Array.from(this.els.slide.elements).filter(slide => slide.getAttribute('aria-hidden') !== 'true')

      if (slides.length >= 2) {
        const observer = new MutationObserver((mutationsList) => {
          mutationsList.forEach(mutation => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
              const allStyled = Array.from(slides).every(slide => slide.hasAttribute('style'))
              if (allStyled) {
                observer.disconnect()
                animateSlides()
                this.thumbnailCarousel = this.setupThumbnailCarousel()
              }
            }
          })
        })

        slides.forEach(slide => {
          observer.observe(slide, { attributes: true })
        })

        const animateSlides = () => {
          setTimeout(() => {
            slides.slice(0, -1).forEach(slide => {
              slide.style.transform = 'translate3d(-150px, 0, 0)'
              slide.style.transition = 'transform 0.5s ease'

              setTimeout(() => {
                slide.style.transform = 'translate3d(0, 0, 0)'
                slide.style.transition = 'transform 0.5s ease'

                setTimeout(() => {
                  slide.style.transition = ''
                }, 500)
              }, 500)
            })
          }, 1000)
        }
      }
    }
  }

  onResize () {
    if(window.innerWidth === this.windowSize) return
    this.windowSize = window.innerWidth
    this.setImageHeight()
    this.setupCheck()
  }

  onThumbnailClick (event) {
    const hash = event.currentTarget.hash

    if (!hash || window.location.hash === hash) return

    this.muteVideos()
  }

  OnVariantChange () {
    this.muteVideos()
    this.setupCheck()
  }

  setupCheck () {
    this.mobileHorizontal = this.dataset?.galleryOptions === 'horizontal'

    const hasCarousel = this.carousel != null

    if (hasCarousel) {
      this.carousel.destroy()
      this.carousel = null
    }

    const hasThumbnailCarousel = this.thumbnailCarousel != null
    if (hasThumbnailCarousel) {
      this.thumbnailCarousel.destroy()
      this.thumbnailCarousel = null
    }

    this.thumbnailCarousel = this.setupThumbnailCarousel()

    this.updateFirstActiveDot()
    this.carousel = this.setupCarousel()
    this.setupLastSlideDrag()
  }

  setImageHeight () {
    const shownSlide = this.els.slide.elements.find((element) => element.ariaHidden === null)
    if (shownSlide?.offsetHeight > 0) {
      document.body.style.setProperty('--first_image_height', `${shownSlide?.offsetHeight}px`)
    }
  }

  setupCarousel () {
    this.els.variantSlides.element.innerText = this.querySelectorAll('[data-product-media-el="slide"]:not([aria-hidden="true"])').length
    this.els.currentSlide.element.innerText = '1'
    this.els.sliderCount.element.setAttribute('aria-active', 'true')
    this.updateCountLabel()

    const showThumbnails = this.els.slides.element.dataset.thumbnailsShow

    let desktopPerView = 1
    if (showThumbnails === "false") {
      desktopPerView = 1.1
    }

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: `${this.els.slide.selector}:not([aria-hidden='true'])`,
        loop: true,
        mode: 'snap',
        rubberband: true,
        slides: {
          perView: 1.1,
        },
        breakpoints: {
          '(min-width: 1000px)': {
            slides: {
              perView: desktopPerView,
            },
          },
        },
        slideChanged: (instance) => this.onSlideChanged(instance),
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  setupThumbnailCarousel () {
    if (this.externalEls.thumbnails?.element == null) {
      return
    }

    return new window.KeenSlider(
      this.externalEls.thumbnails.element,
      {
        selector: `${this.externalEls.thumbnail.selector}:not([aria-hidden='true'])`,
        mode: 'snap',
        rubberband: true,
        vertical: true,
        renderMode: "performance",
        slides: {
          perView: 5,
          spacing: 5
        },
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useArrows({
          next: this.externalEls?.next?.element,
          previous: this.externalEls?.previous?.element,
        }),
      ],
    )
  }

  muteVideos () {
    if (this.els?.['video-controls']?.exists === true) {
      this.els['video-controls'].elements.forEach((el) => {
        if (el instanceof customElements.get('lazy-video-controls') === true) {
          el.muteVideo()
        }
      })
    }
  }

  setupLastSlideDrag () {
    if (this.mobileHorizontal) return
    const slidesArr = document.querySelectorAll(`${this.els.slide.selector}:not([aria-hidden='true'])`)
    const lastSlide = slidesArr[slidesArr.length - 1]

    let dragging = false

    const handleStart = (e) => {
      dragging = true
      this.startY = e.touches ? e.touches[0].clientY : e.clientY
    }

    const handleMove = (e) => {
      if (!dragging) return

      const currentY = e.touches ? e.touches[0].clientY : e.clientY
      if (this.startY > currentY) {
        this.onDragUp()
        dragging = false // Reset the flag to prevent multiple triggers in the same drag session
      }
    }

    const handleEnd = () => {
      dragging = false // Reset the flag when the drag ends
    }

    lastSlide.addEventListener('touchstart', handleStart)
    lastSlide.addEventListener('mousedown', handleStart)

    lastSlide.addEventListener('touchmove', handleMove)
    lastSlide.addEventListener('mousemove', handleMove)

    lastSlide.addEventListener('touchend', handleEnd)
    lastSlide.addEventListener('mouseup', handleEnd)
    lastSlide.addEventListener('mouseleave', handleEnd)
  }

  onDragUp () {
    const rect = this.externalEls.main.element.getBoundingClientRect()
    const offsetTop = rect.top + window.pageYOffset
    window.scrollTo({ top: offsetTop, behavior: 'smooth' })
  }

  onSlideChanged (instance) {
    this.els.currentSlide.element.innerText = instance.track.details.rel + 1
    this.updateCountLabel()
    this.muteVideos()
  }

  updateCountLabel () {
    const { countLabel, currentSlide, variantSlides } = this.els
    if (!countLabel?.exists) return

    countLabel.element.textContent = countLabel.element.dataset.label
      .replace('[current]', currentSlide.element.innerText)
      .replace('[total]', variantSlides.element.innerText)

    if (!countLabel.element.hasAttribute('aria-live')) {
      window.requestAnimationFrame(() => countLabel.element.setAttribute('aria-live', 'polite'))
    }
  }

  updateFirstActiveDot () {
    this.els?.dot?.elements.forEach(dot => {
      dot.removeAttribute('aria-active')
    })

    const firstDot = document.querySelector(`${this.els.dot.selector}:not([aria-hidden='true'])`)
    firstDot.setAttribute('aria-active', 'true')
  }

  updateActiveDot (activeId) {
    this.els?.dot?.elements.forEach(dot => {
      if (!dot.getAttribute('aria-hidden') || dot.getAttribute('aria-hidden') !== 'true') {
        if (dot.getAttribute('href') === `#${activeId}`) {
          dot.setAttribute('aria-active', 'true')
        } else {
          dot.removeAttribute('aria-active')
        }
      }
    })
  }

  onDotClick (e) {
    e.preventDefault()

    this.els.dot.elements.forEach(dot => {
      dot.removeAttribute('aria-active')
    })

    const target = e.target
    target.setAttribute('aria-active', 'true')

    const productId = target.href.split('#')[1]

    // Get all visible slides
    const visibleSlides = Array.from(document.querySelectorAll('.prd-Media_Slide:not([aria-hidden="true"])'))

    // Find the index of the slide that matches the productId
    const targetSlideIndex = visibleSlides.findIndex(slide => slide.id === productId)

    // Move to the found index if it's valid
    if (targetSlideIndex !== -1) {
      this.carousel.moveToIdx(targetSlideIndex)
    }
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMediaCarousel)
}
